import React, { Fragment, useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardTitle,
  Button,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import {
  CREATE_SUBSCRIPTION_URL,
  SELECT_SUBSCRIPTION_URL,
  UPDATE_SUBSCRIPTION_URL,
} from '../../../utils/APIEndpoints';
import { AGENCY_SUBSCRIPTIONS_PAGE } from '../../../utils/AppRoutes';
import {
  getCurrentUserId,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import CustomModalSearch from '../functions/CustomModalSearch';
import { UserIcon } from '../functions/Icons';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CustomLoader from '../../common/CustomLoader';
import InvoiceModalSearch from '../functions/InvoiceModalSearch';
import DatePicker from 'react-datepicker';
import Loader from '../../loader';

function NewSubscriptions() {
  const { id = 0 } = useParams();
  const history = useHistory();
  let location = useLocation();
  const [loading, setLoading] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [editFlow, setEditFlow] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  //search Modal
  const [customerModalFlag, setCustomerModalFlag] = useState(false);
  const [InvoiceModalFlag, setInvoiceModalFlag] = useState(false);

  //Form
  let intialValues = {
    invoiceSendInterval: '',
    subscriptionStartDate: '',
    subscriptionEndDate: '',
  };

  let [subscriptionInitialValues, setSubscriptionInitialValues] =
    useState(intialValues);

  const validationSchema = Yup.object({
    invoiceSendInterval: Yup.number()
      .required('Interval is Required')
      .test(
        'Is positive?',
        'The number must be greater than 0',
        (value) => value > 0
      ),
    subscriptionStartDate: Yup.string().required(
      'Subscription start date is Required'
    ),
    subscriptionEndDate: Yup.string().required(
      'Subscription end date is Required'
    ),
  });

  const { handleChange, values, handleSubmit, errors, touched, setValues } =
    useFormik({
      initialValues: subscriptionInitialValues,
      validationSchema,
      enableReinitialize: true,
      onSubmit: (values) => {
        createCustomer(values);
      },
    });
  const [changeCustomerFlag, setChangeFlag] = useState(false);

  //dateChange
  const dateChange = (date) => {
    setValues({ ...values, subscriptionStartDate: date || '' });
  };

  const dateChangeSecond = (date) => {
    setValues({ ...values, subscriptionEndDate: date || '' });
  };

  // toggle
  const customerToggle = () => {
    setCustomerModalFlag(!customerModalFlag);
    if (selectedInvoice) {
      setChangeFlag(true);
    } else if (selectedCustomer) {
      setChangeFlag(false);
    }
  };

  const invoiceToggle = () => {
    setInvoiceModalFlag(!InvoiceModalFlag);
  };

  //select Customer
  const selectCustomer = (event) => {
    const { detail } = event.currentTarget.dataset;
    const data = JSON.parse(detail || '{}');
    setSelectedCustomer(data);
    customerToggle();
  };

  // select Invoice
  const selectInvoice = (event) => {
    const { details, id } = event.currentTarget.dataset;
    const data = JSON.parse(details || '{}');
    setSelectedInvoice(data);
    setSelectedMaster(parseInt(id));
    setChangeFlag(false);

    invoiceToggle();
  };

  //Show Invoice Info
  const showInvoiceInfo = (event) => {
    event.stopPropagation();
  };

  const back = () => {
    history.push(AGENCY_SUBSCRIPTIONS_PAGE);
  };

  //CREATE / UPDATE SUBCRIPTION API
  const createCustomer = async (values) => {
    if (changeCustomerFlag == true) {
      Swal.fire(getAlertToast('error', 'Please select Subscription'));
    } else {
      setNewLoading(true);
      values.customerId = selectedCustomer.customerId;
      values.invoiceMasterId = selectedMaster;
      values.createdBy = getCurrentUserId();
      values.subscriptionStartDate = moment(
        values.subscriptionStartDate
      ).format('YYYY-MM-DD');
      values.subscriptionEndDate = moment(values.subscriptionEndDate).format(
        'YYYY-MM-DD'
      );
      // console.log('submitted Values ', values);
      try {
        const options = {
          method: editFlow == 'edit' ? 'PUT' : 'POST',
          url:
            editFlow == 'edit'
              ? UPDATE_SUBSCRIPTION_URL
              : CREATE_SUBSCRIPTION_URL,
          headers: authHeader(),
          data:
            editFlow == 'edit'
              ? {
                  subscriptionId: parseInt(id),
                  invoiceMasterId: selectedMaster,
                  customerId: selectedCustomer.customerId,
                  invoiceSendInterval: values.invoiceSendInterval,
                  subscriptionStartDate: moment(
                    values.subscriptionStartDate
                  ).format('YYYY-MM-DD'),
                  subscriptionEndDate: moment(
                    values.subscriptionEndDate
                  ).format('YYYY-MM-DD'),
                }
              : values,
        };
        const response = await API(options);
        // console.log('Response ', response);
        const { status, message } = response.data;
        if (status === 'Success') {
          Swal.fire(getAlertToast('success', message));
          history.push(AGENCY_SUBSCRIPTIONS_PAGE);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast('error', data.message));
        }
      } finally {
        setNewLoading(false);
      }
    }
  };

  //SELECT SUBSCRIPTION API
  const loadValues = async () => {
    try {
      setLoading(true);
      const options = {
        method: 'GET',
        url: SELECT_SUBSCRIPTION_URL,
        headers: authHeader(),
        params: { subscriptionId: parseInt(id) },
      };
      const response = await API(options);

      const { status, data } = response.data;
      // console.log('Data ', data);
      if (status === 'Success') {
        setSelectedCustomer(data);
        setSelectedMaster(data.invoiceMasterId);
        setSelectedInvoice(data);
        setSubscriptionInitialValues({
          invoiceSendInterval: data.invoiceSendInterval,
          subscriptionStartDate: new Date(data.subscriptionStartDate),
          subscriptionEndDate: new Date(data.subscriptionEndDate),
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[2] || '/';
    setEditFlow(currentMenuToActive);
  }, [location]);

  //Edit Subcription
  useEffect(() => {
    if (id) {
      loadValues();
    }
  }, []);

  return (
    <Fragment>
      <Container fluid className="mt-5">
        {/* Customer Modal Search*/}
        {customerModalFlag && (
          <CustomModalSearch
            toggle={customerToggle}
            modal={customerModalFlag}
            selectCallBack={selectCustomer}
          />
        )}

        {/* Invoice Modal Search */}
        {InvoiceModalFlag && (
          <InvoiceModalSearch
            toggle={invoiceToggle}
            modal={InvoiceModalFlag}
            selectCallBack={selectInvoice}
            data={selectedCustomer.customerName}
            showInvoiceInfo={showInvoiceInfo}
          />
        )}

        <Card body>
          <CardTitle tag="h6" className="item-center">
            {selectedCustomer ? 'Create an Subcription' : 'Choose an Customer'}
            <div className="invoice-BTn-l">
              <Button color="primary" onClick={back}>
                <i className="fas fa-arrow-left" /> Back
              </Button>
            </div>
          </CardTitle>
          <small>
            To send recurring invoices, create a subscription with a product and
            plan
          </small>

          {/* Edit Loading */}
          {loading ? (
            <center>{loading && <Loader />}</center>
          ) : (
            !selectedInvoice && (
              <div className="select-customer">
                <h6>{selectedCustomer ? 'Invoices' : 'Customer'}</h6>

                <div className="box">
                  <UserIcon />
                  <h6>
                    {selectedCustomer
                      ? 'Select a invoice to begin creating an Subscription.'
                      : 'Select a customer to begin creating an Subscription'}
                  </h6>
                  <Button
                    color="primary"
                    onClick={selectedCustomer ? invoiceToggle : customerToggle}
                  >
                    {selectedCustomer
                      ? 'Select a Invoice'
                      : 'Select a customer'}
                  </Button>
                </div>
              </div>
            )
          )}

          {selectedInvoice && (
            <>
              <Row>
                <Col md="6">
                  <div className={'select-customer-after'}>
                    <h6>Customer</h6>
                    <div className="box">
                      <div className="name">
                        <UserIcon />
                        <div key={selectedCustomer.customerId}>
                          <p>
                            {selectedCustomer ? selectedCustomer.email : '-'}
                          </p>
                          <small>
                            {selectedCustomer
                              ? selectedCustomer.customerName
                              : '-'}
                          </small>
                        </div>
                        <div className="btn-sec">
                          <Button
                            color="primary"
                            onClick={customerToggle}
                            disabled={editFlow == 'edit'}
                          >
                            Change Customer
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className={'select-customer-after'}>
                    <h6>Subscription</h6>
                    <div className="box">
                      <div className="name">
                        <UserIcon />
                        <div>
                          <p>
                            {selectedInvoice && changeCustomerFlag == true
                              ? ''
                              : selectedInvoice
                              ? `Invoice No : ${selectedInvoice.invoiceNumber}`
                              : ''}
                          </p>
                          <p>
                            {selectedInvoice && changeCustomerFlag == true
                              ? ''
                              : selectedInvoice
                              ? `Amount : ${selectedInvoice.paymentAmount}`
                              : ''}
                          </p>
                        </div>
                        <div className="btn-sec">
                          <Button
                            color="primary"
                            onClick={invoiceToggle}
                            disabled={editFlow == 'edit'}
                          >
                            {selectedInvoice ? 'Edit Subscription' : ''}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {/* Form */}
              <div style={{ marginTop: '2rem' }}>
                <h6>Form</h6>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label for="invoiceSendInterval">
                          Invoice Interval in Days
                        </Label>
                        <Input
                          type="number"
                          name="invoiceSendInterval"
                          id="invoiceSendInterval"
                          onChange={handleChange}
                          value={values.invoiceSendInterval}
                          // invalid={
                          //   errors.invoiceSendInterval &&
                          //   touched.invoiceSendInterval ?
                          //    true
                          //    : false
                          // }
                          placeholder="Enter Invoice Interval in Days"
                          min={1}
                        />
                        <div className="error">
                          {errors.invoiceSendInterval &&
                          touched.invoiceSendInterval
                            ? errors.invoiceSendInterval
                            : ''}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="subscriptionStartDate">
                          Subscription Start Date
                        </Label>
                        <br />
                        <DatePicker
                          name="subscriptionStartDate"
                          className={'form-control'}
                          style={{
                            zIndex: '9999 !important',
                            width: '100% !important',
                          }}
                          selected={values.subscriptionStartDate}
                          onChange={dateChange}
                          minDate={Date.now()}
                          placeholderText="Subscription Start Date"
                          width="100%"
                          popperPlacement="top-end"
                          popperModifiers={{
                            flip: {
                              behavior: ['bottom'],
                            },
                            preventOverflow: {
                              enabled: false,
                            },
                            hide: {
                              enabled: false,
                            },
                          }}
                        />
                        <div className="error">
                          {errors.subscriptionStartDate &&
                          touched.subscriptionStartDate
                            ? errors.subscriptionStartDate
                            : ''}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="subscriptionEndDate">
                          Subscription End Date
                        </Label>
                        <br />
                        <DatePicker
                          name="subscriptionEndDate"
                          className="form-control"
                          style={{
                            zIndex: '9999 !important',
                            width: '100% !important',
                          }}
                          selected={values.subscriptionEndDate}
                          onChange={dateChangeSecond}
                          minDate={Date.now()}
                          placeholderText="Subscription End Date"
                          width="100%"
                          popperPlacement="top-end"
                          popperModifiers={{
                            flip: {
                              behavior: ['bottom'],
                            },
                            preventOverflow: {
                              enabled: false,
                            },
                            hide: {
                              enabled: false,
                            },
                          }}
                        />
                        <div className="error">
                          {errors.subscriptionEndDate &&
                          touched.subscriptionEndDate
                            ? errors.subscriptionEndDate
                            : ''}
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button type="submit">
                    {newLoading && <CustomLoader loading={newLoading} />}
                    {editFlow == 'edit' ? 'Save' : 'Submit'}
                  </Button>
                </Form>
              </div>
            </>
          )}
        </Card>
      </Container>
    </Fragment>
  );
}

export default NewSubscriptions;
